import { useAuth0 } from '@auth0/auth0-react'
import { Navigate, useLocation } from 'react-router-dom'
import { BrandStack } from './BrandStack'
import { NeonBackground } from './NeonBackground'
import './Login.css'

export function Login() {
  const { loginWithRedirect, isAuthenticated } = useAuth0()
  const location = useLocation()
  const returnTo = (location.state as { returnTo?: string })?.returnTo ?? '/'

  if (isAuthenticated) {
    return <Navigate to={returnTo} replace />
  }

  const handleSignIn = () => {
    void loginWithRedirect({ appState: { returnTo } })
  }

  return (
    <div
      style={{
        position: 'relative',
        minHeight: '100vh',
        overflow: 'hidden',
        background: '#0a0a0f',
        color: 'white',
      }}
    >
      <NeonBackground />
      <BrandStack onSignIn={handleSignIn} />
    </div>
  )
}
